import { render, staticRenderFns } from "./pointVolunteerList.vue?vue&type=template&id=b9c79ff2&scoped=true"
import script from "./pointVolunteerList.vue?vue&type=script&lang=js"
export * from "./pointVolunteerList.vue?vue&type=script&lang=js"
import style0 from "./pointVolunteerList.vue?vue&type=style&index=0&id=b9c79ff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c79ff2",
  null
  
)

export default component.exports